import { formatLongDate } from '@cyntox/common/ui';
import { useApp } from '../state/AppContext';
import { recentWeeks } from '../state/periods';

/** This week and the twelve before it. Weeks end on Wednesday. */
export function WeekSelect({ value, onChange }: { value: string; onChange: (week: string) => void }) {
  const { reference } = useApp();
  const weeks = recentWeeks(reference.currentWeekEnding);
  if (!weeks.includes(value)) weeks.push(value);
  return (
    <select className="control" aria-label="Week" value={value} onChange={(e) => onChange(e.target.value)}>
      {weeks.map((w) => (
        <option key={w} value={w}>
          {w === reference.currentWeekEnding ? 'This week' : 'Week'} ending {formatLongDate(w)}
        </option>
      ))}
    </select>
  );
}

/**
 * Offers only the regions this person's access reaches. "All regions" appears
 * only when that is really all of them, and the control locks when there is
 * exactly one.
 */
export function RegionSelect({
  allowed, value, onChange,
}: {
  /** Region codes the access reaches; null means every region. */
  allowed: string[] | null;
  value: string;
  onChange: (region: string) => void;
}) {
  const { reference } = useApp();
  const options = allowed === null ? reference.regions : reference.regions.filter((r) => allowed.includes(r.regionCode));
  const only = allowed && allowed.length === 1 ? allowed[0] : null;
  return (
    <select
      className="control"
      aria-label="Region"
      value={only ?? value}
      disabled={!!only}
      title={only ? 'Your access is limited to this region' : undefined}
      onChange={(e) => onChange(e.target.value)}
    >
      {!only && <option value="all">{allowed === null ? 'All regions' : 'All my regions'}</option>}
      {options.map((r) => <option key={r.regionCode} value={r.regionCode}>{r.name}</option>)}
    </select>
  );
}
